<template>
    <layout class="device-use-history-wrapper">
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
            <ul class="history-list">
                <li class="history-item" v-for="item in list" :key="item.id">
                    <div class="top-row">
                        <span>{{item.memberName}}</span>
                        <div>
                            <img src="../assets/img/time.png" alt="" class="icon-clock"><span class="time">{{item | runDuration}}</span>
                        </div>
                    </div>
                    <div class="desc-row">设备编号：{{item.deviceNo}}</div>
                    <div class="desc-row">开始时间：{{item.startTime}}</div>
                    <div class="desc-row">结束时间：{{item.endTime|fillEmpty}}</div>
                </li>
            </ul>
        </van-list>
    </layout>
</template>
<script>
    import moment from 'moment';
    export default {
        name: "DeviceUseHistory",
        data() {
          return {
              page: {
                  current: 1,
                  size: 10
              },
              list: [],
              loading: false,
              finished: false,

          }
        },
        methods: {

            onLoad() {
                this.loadDeviceUsePage(this.page.current + 1);
            },
            /**
             * 使用记录
             * @returns {Promise<void>}
             */
            async loadDeviceUsePage(current) {
                this.loading = true;
                try {
                    let {data} = await this.$req.deviceUsePage({
                        size: this.page.size,
                        current: current
                    });
                    data.records.forEach(item => {
                        this.list.push(item);
                    });

                    this.page.current = data.current;
                    if (this.list.length >= data.total) {
                        this.finished = true;
                    }
                } catch (e) {
                    //TODO
                } finally {
                    this.loading = false;
                }
            }
        },
        filters: {
            runDuration(value) {
                if (value.startTime && value.endTime) {
                    let duration = moment(value.endTime, 'YYYY-MM-DD HH:mm:ss').toDate().getTime() - moment(value.startTime, 'YYYY-MM-DD HH:mm:ss').toDate().getTime();
                    // console.log(moment(value.startTime, 'YYYY-MM-DD HH:mm'));
                    return Math.round(duration / 1000) + "秒";
                } else {
                    return '--';
                }
            }
        },
        mounted() {
            this.loadDeviceUsePage(this.page.current);
        }
    }
</script>